import { SiteStoresProvider } from 'es/app/views/site/SiteStore';
import { SystemStoresProvider } from 'es/app/views/system/SystemStore';
import { Outlet } from 'react-router-dom';
import { useActiveSite } from 'es/app/store/hooks';
import { Fragment } from 'react';

export const RoutesOutlet = () => {
    const activeSite = useActiveSite();
    return (
        <Fragment key={activeSite?.toString()}>
            <SystemStoresProvider>
                <SiteStoresProvider>
                    <Outlet />
                </SiteStoresProvider>
            </SystemStoresProvider>
        </Fragment>
    );
};
